// Copyright 2022, Imprivata, Inc.  All rights reserved.

import { CodingContext, getRSAPublicKey } from '@imprivata-cloud/data-privacy-js';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { PlatformContext } from './PlatformContext';

export const usePlatform = () => {
  const context = useContext(PlatformContext);
  if (context === undefined) {
    throw new Error('usePlatform must be used within a PlatformContext');
  }
  return context;
};

export const useCodingContext = (metadataUrl: string) => {
  return useQuery({
    queryKey: ['public-key'],
    queryFn: async () => {
      try {
        const publicKey = await getRSAPublicKey(`${metadataUrl}/data-privacy/public.json`);
        return await CodingContext.createContextV2(publicKey.key, publicKey.version);
      } catch {
        return CodingContext.createContextV1();
      }
    },
  });
};
